<template>
  <span>
    <AiInput
      cls="phone-input"
      v-model="phone"
      :placeholder="$t('inputPhone')"
      prop="phone"
      :maxlength="50"
      :error="errorObj['phone']"
      @onClearError="onClearError"
    >
      <template slot="attach">
        <div class="area-code">+86</div>
      </template>
    </AiInput>
    <AiInput
      cls="code-input"
      v-model="code"
      :maxlength="18"
      :placeholder="$t('inputCode')"
      prop="code"
      :error="errorObj['code']"
      @onClearError="onClearError"
    >
      <template slot="attach">
        <div
          :class="{
            'send-code': true,
            disabled: sendCodeDisabled,
          }"
          @click="sendCode"
        >
          {{ sendCodeText }}
        </div>
      </template>
    </AiInput>
    <div class="login-btn-wrap">
      <div
        :class="{
          'login-btn': true,
          disabled: disabledBtn,
        }"
        @click="!loginLoading ? handleLogin() : ''"
      >
        {{ $t("loginRegister") }}
      </div>
    </div>
  </span>
</template>
<script>
import { getDomainFn } from "@/utils/env";
import registerCode from "@/common/registerCode.js";
import { LocalDataUtil } from "@/common/util";
import { isPhone } from "@/utils/reg_exp.js";
import AiInput from "@/components/Input/Index.vue";
let timer = null;

const trimString = (str) => {
  return str.replace(/\s+/g, "");
};

export default {
  name: "SignIn",
  components: {
    AiInput,
  },
  props: {
    isAgree: {
      type: Boolean,
      default: true,
    },
  },
  watch: {},
  data() {
    return {
      phone: "",
      code: "",
      errorObj: {
        phone: "",
        code: "",
      },
      sendCodeDisabled: false,
      sendCodeText: this.$t("sendCode"),
    };
  },
  mounted() {},
  computed: {
    loginLoading() {
      return this.$store.state.loginLoading;
    },
    disabledBtn() {
      if (!isPhone(trimString(this.phone)) || !this.code || !this.isAgree) {
        return true;
      }
      return false;
    },
  },
  methods: {
    async sendCode() {
      if (this.sendCodeDisabled) {
        return;
      }
      if (!isPhone(trimString(this.phone))) {
        this.$set(this.errorObj, "phone", this.$t("phoneError"));
        return;
      } else {
        this.$set(this.errorObj, "phone", "");
      }
      let count = 60;
      this.sendCodeText = this.$t("sendCodeSuccess", { num: count });
      this.sendCodeDisabled = true;
      timer = setInterval(() => {
        count--;
        this.sendCodeText = this.$t("sendCodeSuccess", { num: count });
        if (count <= 0) {
          clearInterval(timer);
          this.sendCodeText = this.$t("sendCode");
          this.sendCodeDisabled = false;
        }
      }, 1000);
      const tongdun = localStorage.getItem("tongdunBlackBox");
      const res = await this.$store.dispatch("postPhoneCode", {
        phone: trimString(this.phone),
        tongdun,
      });
      if (res.status === "200") {
        this.$toast({
          type: "success",
          message: this.$t("codeSendSuccess"),
        });
      } else {
        if (res.code === "12101") {
          this.$toast({
            type: "error",
            message: this.$t("codeSendError"),
          });
          return;
        }
        clearInterval(timer);
        this.sendCodeText = this.$t("sendCode");
        this.sendCodeDisabled = false;
        this.$toast({
          type: "error",
          message: this.$t("codeSendFail"),
        });
      }
    },

    onClearError(val) {
      this.errorObj[val] = "";
    },
    async handleLogin() {
      if (this.disabledBtn) return;
      this.errorObj = {};
      if (!isPhone(trimString(this.phone))) {
        this.$set(this.errorObj, "phone", "请输入正确的手机号");
      } else {
        this.$set(this.errorObj, "phone", "");
      }

      if (this.errorObj["phone"] || this.errorObj["code"]) {
        return;
      }
      const tongdun = localStorage.getItem("tongdunBlackBox");
      const params = {
        phone: trimString(this.phone),
        code: this.code,
        tongdun,
      };
      // 直接调用登录接口
      const res = await this.$store.dispatch("postPhoneLogin", params);
      if (res.status === "200") {
        LocalDataUtil.setItem("aispacewebtoken", res.data.token);
        LocalDataUtil.setItem(
          "aipacewebuserinfo",
          JSON.stringify(res.data.user_info)
        );
        if (res.data.user_info.invited == 0) {
          if (LocalDataUtil.getItem("registerode")) {
            this.$store.commit("setShowLogin", false);
            registerCode();
          } else {
            this.$store.commit("setLoginStatus", "Invited");
            // if (!getDomainFn()) {
            //   this.$store.commit("setLoginStatus", "Invited");
            // } else {
            //   if (res.data.user_info?.is_new === 1) {
            //     this.$store.commit("setLoginStatus", "Invited");
            //   } else {
            //     this.$store.commit("setShowLogin", false);
            //     this.$router.replace("edit");
            //   }
            // }
          }
        } else {
          this.$store.commit("setShowLogin", false);
          this.$router.replace("edit");
        }
        this.$toast({
          type: "success",
          message: this.$t("loginSuccess"),
          duration: 8,
        });
      } else {
        this.$toast({
          type: "error",
          message: this.$t("codeError"),
        });
      }
    },
  },
  beforeDestroy() {
    clearInterval(timer);
  },
};
</script>

<style lang="less" scoped>
.phone-input {
  /deep/ input {
    padding-left: 45px;
  }
  .area-code {
    position: absolute;
    left: 12px;
    top: 9px;
    color: #a9a9a9;
  }
}

.code-input {
  .send-code {
    position: absolute;
    right: 0px;
    top: 0px;
    height: 36px;
    line-height: 36px;
    min-width: 60px;
    padding-right: 14px;
    color: #000;
    font-size: 12px;
    cursor: pointer;
    text-decoration: underline;
    &.disabled {
      cursor: default;
      color: #a9a9a9;
      text-decoration: none;
    }
    &:before {
      content: "";
      height: 14px;
      border-left: 1px solid #a9a9a9;
      position: absolute;
      left: -8px;
      top: 11px;
    }
  }
}

.login-btn-wrap {
  padding-top: 7px;
  .login-btn {
    cursor: pointer;
    width: 100%;
    height: 39px;
    background: #8873ff;
    border-radius: 71px;
    font-size: 12px;
    font-family: PingFangTC-Medium, PingFangTC;
    font-weight: 500;
    color: #fff;
    text-align: center;
    line-height: 39px;
    &:active {
      opacity: 0.9;
    }
    &.disabled {
      opacity: 0.6;
      cursor: default;
      &:active {
        opacity: 0.6;
      }
    }
  }
}
</style>
